module.exports = __webpack_public_path__ + "img/sportstrade-small.00473b05.png";